<template>
  <div class="choosenSubItem b_b full_h">
    <div class="helpTitle font24">
      {{ choosenSubItem && choosenSubItem.type }}
    </div>
    <img src="../../../../assets/borderImg.png" style="width: 100%" alt="" />
    <div class="m_t_20 o_a" style="height: calc(100% - 140px); color: #66667f">
      <div
        class="font16 p_t_b_10 fw c_p"
        @click="toDetail(item)"
        v-if="item.id !== 29"
        v-for="(item, index) of list"
        :key="index"
      >
        {{ item.question }}
      </div>
    </div>
    <!-- <page
      class="m_t_10"
      v-on:on-getList="getAllList($event)"
      :totalPage="totalPage"
      :page="page"
      :explain="1"
    ></page> -->
  </div>
</template>

<script>
export default {
  props: ['choosenSubItem'],
  data () {
    return {
      list: []
    }
  },
  mounted () {
    document.title = '百钢一下 | 钢铁电商，百炼成钢'
    if (this.choosenSubItem) {
      this.getList()
    }
  },
  watch: {
    'choosenSubItem.id': function () {
      this.getList()
    }

  },
  methods: {
    getList () {
      this.$axiox
        .post(
          `/baigang/shop/question/queryDetail/${this.choosenSubItem.id}`,
          {}
        )
        .then((p) => {
          this.list = p.data
        })
    },
    toDetail (item) {
      this.$router.push({
        path: '/helpDetail',
        query: {
          id: this.choosenSubItem.id,
          subId: item.id
        }
      })
    }
  }
}
</script>

<style>
.choosenSubItem {
  padding: 30px;
}
.helpTitle {
}
</style>



// WEBPACK FOOTER //
// src/components/pages/page/help/helpSubList.vue